import { render } from "./VideoCall.vue?vue&type=template&id=029508d7&scoped=true"
import script from "./VideoCall.vue?vue&type=script&lang=ts"
export * from "./VideoCall.vue?vue&type=script&lang=ts"

import "./VideoCall.vue?vue&type=style&index=0&id=029508d7&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-029508d7"

export default script